/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface Payretailers
 */
export class Payretailers {
    /**
     *
     * @type {string}
     * @memberof Payretailers
     */
    _id: string;
    /**
     *
     * @type {string}
     * @memberof Payretailers
     */
    namespace: string;
    /**
     *
     * @type {string}
     * @memberof Payretailers
     */
    type: string;
    /**
     *
     * @type {string}
     * @memberof Payretailers
     */
    apiKey: string;
    /**
     *
     * @type {string}
     * @memberof Payretailers
     */
    username: string;
    /**
     *
     * @type {string}
     * @memberof Payretailers
     */
    password: string;
    /**
     *
     * @type {boolean}
     * @memberof Payretailers
     */
    sandbox: boolean;
    /**
     *
     * @type {boolean}
     * @memberof Payretailers
     */
    autoApprove: boolean;
    /**
     *
     * @type {string}
     * @memberof Payretailers
     */
    version: string;
}
